export default __webpack_public_path__ + "static/faq-title-506d1e6a25d4327fe80e01ef81180ef4.png";